<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div
        v-show="$route.path != '/Machine/ManagePhase/Import'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-barcode"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>คำค้นหา :</label>
                  <input
                    id="MbKeyword"
                    name="MbKeyword"
                    v-model="MbKeyword"
                    type="text"
                    class="form-control"
                    placeholder="รหัสอ้างอิง เลขเฟส เลขล็อต รหัสสินค้า"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="ManagePhase/Import"
                  tag="button"
                  title="เพิ่มข้อมูล Phase(Excel)"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['ADMIN_EQUIPMENT_LEASING'])"
                >
                  <!-- 'MANAGER_EQUIPMENT_LEASING' -->
                  <!-- v-if="this.$root.canShow(['ADMIN_EQUIPMENT_LEASING', 'USER_EQUIPMENT_LEASING'])" -->
                  <i class="fas fa-file-import"></i> Import
                </router-link>

                <button
                  tag="button"
                  title="ดาวน์โหลด Template Phase"
                  class="btn btn-outline-brand"
                  @click="downloadTemplate"
                  v-if="this.$root.canShow(['ADMIN_EQUIPMENT_LEASING'])"
                >
                  <!-- v-if="this.$root.canShow(['ADMIN_EQUIPMENT_LEASING', 'USER_EQUIPMENT_LEASING'])" -->
                  <i class="fas fa-download"></i> Template
                </button>

                <router-link
                  to="ManagePhase/DownloadPhase"
                  tag="button"
                  title="ดาวน์โหลด Phase"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['ADMIN_EQUIPMENT_LEASING'])"
                >
                  <!-- v-if="this.$root.canShow(['ADMIN_EQUIPMENT_LEASING', 'USER_EQUIPMENT_LEASING'])" -->
                  <i class="fas fa-file-export"></i> Download
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="phaseTable"
              >
                <thead>
                  <tr>
                    <th class="all">Phase</th>
                    <th class="all">Lot</th>
                    <th class="all">Material Code</th>
                    <th class="all">รหัสอ้างอิง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

//let Actions = Vue.extend({
//  template: `
//  <div>
//    <a href="#" @click.prevent="detail" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
//      <i class="fa fa-search"></i>
//    </a>
//  </div>`,
//  methods: {
//    detail: function() {
//      router.push({
//        path: `/Master/ManageBarcode/Detail/${this.data.barcodeId}`
//      });
//    }
//  }
//});

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;
    return {
      MbKeyword: "",
    };
  },
  methods: {
    formReset: function(e) {
      this.MbKeyword = "";
      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#phaseTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    downloadTemplate: function(e) {
      e.preventDefault();
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดาวโหลด Template Phase กรุณารอสักครู่...",
      });
      var win = window.open("/Api/MasterPhase/DownloadTemplate", "_blank");
      win.focus(KTApp.unblockPage());
    },
    reloadDataTable: function(resetPaging = false) {
      $("#phaseTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
  },
  async mounted() {
    let self = this;

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#phaseTable");
    table.DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/MasterPhase/Search",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          return JSON.stringify(
            $.extend(d, {
              SearchKeyword: self.MbKeyword,
              RefCode: [],
            })
          );
        },
      },

      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [100, 500],

      pageLength: 100,

      language: {
        lengthMenu: "Display _MENU_",
      },

      // Order settings
      order: [[1, "desc"]],
      columns: [
        { data: "phase" },
        { data: "lot" },
        { data: "materialCode" },
        { data: "refCode" },
        //{
        //  data: "barcodeId",
        //  className: "text-center",
        //  width: "15%",
        //  orderable: false,
        //  render: function(data, type, full, meta) {
        //    return '<div class="actions"></div>';
        //  }
        //}
      ],
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });
    //.on("draw.dt", function () {
    //    $(".actions").each(function (i, el) {
    //        var $dt = table.DataTable();
    //        var $tr = $(el)
    //            .parents("tr")
    //            .first();
    //        var data = $dt.row($tr).data();
    //        if (data) {
    //            data.showDetailButton = self.$root.canShow([
    //                "MANAGE_MASTER",
    //                "MANAGER_EQUIPMENT_LEASING"
    //            ]);
    //            new Actions({ data: { data }, parent: self }).$mount(el);
    //        }
    //    });
    //});
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Phase/ManagePhase.vue